const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

/**
 * Formats a Date object to time string (HH:MM in 24-hour format)
 */
export function formatTime(date: Date): string {
  return date.toLocaleTimeString(navigator.language, TIME_FORMAT_OPTIONS);
}

/**
 * Returns the current time formatted as HH:MM in 24-hour format
 */
export function formatTimestamp(): string {
  return formatTime(new Date());
}

/**
 * Converts a timestamp to a readable date string with time
 * @param timestamp - Unix timestamp (seconds or milliseconds) or ISO string
 * @returns Formatted string like "Jan 1, 2024, 14:30"
 */
export function timestampToReadableDate(timestamp: number | string): string {
  const ms =
    typeof timestamp === "number" && timestamp < 1e10
      ? timestamp * 1000
      : timestamp;
  const date = new Date(ms);

  const datePart = date.toLocaleDateString(navigator.language, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const timePart = formatTime(date);

  return `${datePart}, ${timePart}`;
}
